import { render, staticRenderFns } from "./global-header-search.vue?vue&type=template&id=52d99732&scoped=true&"
import script from "./global-header-search.vue?vue&type=script&lang=js&"
export * from "./global-header-search.vue?vue&type=script&lang=js&"
import style0 from "./global-header-search.vue?vue&type=style&index=0&id=52d99732&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d99732",
  null
  
)

export default component.exports